module.exports = __webpack_public_path__ + "img/noimage.300f4a6f.png";